<script lang="ts" setup>
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import ToggleButton from "@/components/atoms/button/ToggleButton.vue";

defineProps({
  isSortApplied: {
    type: Boolean,
    default: false
  }
});

const emits = defineEmits(["click-sort"]);

const onClickSort = () => {
  emits("click-sort");
};
</script>

<template>
  <div class="d-inline-block">
    <div class="sort-button" data-testid="sort-button">
      <div class="sort-phrase">
        <FeatherIcon icon="bar-chart" class="rotated-flipped-icon" />距離順
        <ToggleButton :checked="isSortApplied" @click="onClickSort" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.rotated-flipped-icon {
  // FeatherIconにFigma通りのアイコンが存在しなかったため、CSSで回転させて反転させている
  transform: rotate(90deg) scaleX(-1);
}

.sort-button {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: #31373f;

  .sort-phrase {
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: center;
  }

  svg {
    width: 24px;
    height: 24px;
    color: $mild;
  }
}
</style>
